/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Component, OnInit, EventEmitter, Output, Input} from '@angular/core';

import { FEET_TO_METERS_MULTIPLIER } from '../../app-constants';

declare var $: any;

@Component({
  selector: 'app-set-scale-finish-dialog',
  templateUrl: './set-scale-finish-dialog.component.html'
})
export class SetScaleFinishDialogComponent {
  
  @Output()
  setScale = new EventEmitter<number>();
  
  mNumberOfPixels: number = null;
  
  mMeasurementValue: number = null;
  mMeasurementType = MeasurementType.FEET;
  
  mId = 'setScaleFinishDialog';
  mDialogHeaderId = 'setScaleFinishDialogHeader';
  mAvailableMeasurementTypes = [MeasurementType.FEET, MeasurementType.YARDS, MeasurementType.MILES, MeasurementType.METERS, MeasurementType.KILOMETERS];
  
  
  show(numberOfPixels: number): void {
    console.log("show() - # of Pixels: " + numberOfPixels);
    this.mNumberOfPixels = numberOfPixels;
    this.mMeasurementType = MeasurementType.FEET;
    this.mMeasurementValue = null;
    $(`#${this.mId}`).modal("show");
  }
  
  hide(): void {
    console.log("hide()");
    $(`#${this.mId}`).modal("hide");
  }
  
  setScaleClicked(): void {
    console.log("setScaleClicked() - Value: " + this.mMeasurementValue + ", Type: " + this.mMeasurementType);
    const valueInMeters = this.getValueInMeters();
    if (valueInMeters != null) {
      const newScale = this.mNumberOfPixels / valueInMeters;
      this.setScale.emit(newScale);
      this.hide();
    }
  }
  
  getValueInMeters(): number {
    if (this.mMeasurementValue != null && this.mMeasurementValue > 0 && this.mMeasurementType != null) {
      switch (this.mMeasurementType) {
        case MeasurementType.FEET: {
          return this.mMeasurementValue * FEET_TO_METERS_MULTIPLIER;
        }
        case MeasurementType.YARDS: {
          return this.mMeasurementValue * 0.9144;
        }
        case MeasurementType.MILES: {
          return this.mMeasurementValue * 1609.34;
        }
        case MeasurementType.METERS: {
          return this.mMeasurementValue;
        }
        case MeasurementType.KILOMETERS: {
          return this.mMeasurementValue / 1000;
        }
      }
    }
    return null;
  }
  
}

export enum MeasurementType {
  FEET = 'FEET',
  YARDS = 'YARDS',
  MILES = 'MILES',
  METERS = 'METERS',
  KILOMETERS = 'KILOMETERS'
}
